import React from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import './MicButton.css';

interface MicButtonProps {
  isRecording: boolean;
  isDisabled: boolean;
  onStartRecording: () => void;
  onStopRecording: () => void;
  recordingDuration: number;
}

export const MicButton: React.FC<MicButtonProps> = ({
  isRecording,
  isDisabled,
  onStartRecording,
  onStopRecording,
  recordingDuration,
}) => {
  const handleMouseDown = (e: React.MouseEvent) => {
    console.log("Start recording dddffd");
    e.preventDefault();
    if (!isDisabled) {
      onStartRecording();
    }
  };

  const handleMouseUp = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isRecording) {
      onStopRecording();
    }
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    e.preventDefault();
    if (!isDisabled) {
      onStartRecording();
    }
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    e.preventDefault();
    if (isRecording) {
      onStopRecording();
    }
  };

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    return false;
  };

  const formatDuration = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <View style={styles.container}>
      <div
        className={`mic-button ${isRecording ? 'recording' : ''} ${isDisabled ? 'disabled' : ''}`}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onContextMenu={handleContextMenu}
        style={styles.button}
      >
        <MaterialIcons
          name={isRecording ? 'mic' : 'mic-none'}
          size={24}
          color={isDisabled ? '#999' : (isRecording ? '#ff4444' : '#ffffff')}
        />
      </div>
      {/* {isRecording && (
        <div className="recording-duration" style={styles.duration}>
          {formatDuration(recordingDuration)}
        </div>
      )} */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: '#4A90E2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'all 0.2s ease',
  },
  duration: {
    position: 'absolute',
    bottom: -20,
    fontSize: 12,
    color: '#666',
  },
});

export default MicButton;
